import styled, { keyframes } from 'styled-components/macro';

const SpinAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.div`
  width: 58px;
  height: 58px;
  border: 7px solid #9de2ff;
  border-top-color: transparent;
  border-radius: 50%;
  animation: ${SpinAnimation} 1s linear infinite;
  z-index: 500;
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`;

export const Wrapper = styled.div`
  position: relative;
  width: 70px;
  height: 70px;
`;
